import { Injectable } from '@angular/core';
import { consoleHelper } from 'lib/helpers/console-helper.class.js';
import { environment } from 'src/app/environments/environment.js';

export type LocalStorageName = 'ActiveDialogSection';

@Injectable({
	providedIn: 'root'
})
export class LocalStorageService {
	setObject<T>(name: LocalStorageName, value: T | undefined): void {
		try {
			if (value) {
				this.setItem(name, JSON.stringify(value));
			} else {
				this.setItem(name, '');
			}
		} catch (err) {
			consoleHelper.logToConsole({
				type: 'Error',
				message: `Could set object in data storage for name '${name}'`,
				data: err
			});
		}
	}

	getObject<T>(name: LocalStorageName): T | undefined {
		try {
			const value = this.getItem(name);

			if (value) {
				return JSON.parse(value) as T;
			}
			return undefined;
		} catch (err) {
			consoleHelper.logToConsole({
				type: 'Error',
				message: `Could get or parse object from storage for name '${name}'`,
				data: err
			});

			return undefined;
		}
	}

	setItem(name: LocalStorageName, value: string): void {
		try {
			localStorage.setItem(this.getFullLocalStorageName(name), value);
		} catch (err) {
			consoleHelper.logToConsole({
				type: 'Error',
				message: `Could set item in data storage for name '${name}'`,
				data: err
			});
		}
	}

	getItem(name: LocalStorageName): string | undefined {
		try {
			return localStorage.getItem(this.getFullLocalStorageName(name)) ?? undefined;
		} catch (err) {
			consoleHelper.logToConsole({
				type: 'Error',
				message: `Could get item from storage for name '${name}'`,
				data: err
			});

			return undefined;
		}
	}

	private getFullLocalStorageName(name: LocalStorageName): string {
		return `${environment.appName}_${name}`;
	}
}
